module.exports = __webpack_public_path__ + "img/maduo1.1dc90e9a.jpg";